import React, { useState, useEffect} from 'react';
import './Banner.css';
import axios from './axios';
import requests from './requests';

const baseUrlImages = "https://image.tmdb.org/t/p/original/"

function Banner() {

    function truncate (str, n)  {
        return str?.length > n ? str.substr(0, n-1) + "..." : str;
    };

    const [movie, setMovie] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const request = await axios.get(requests.fetchNetflixOriginals)
            setMovie(request.data.results[Math.floor(Math.random() * request.data.results.length -1)]) //to get a random movie in the banner everytime the component loads //
            return request
        }
        fetchData()
    }, []);

  return (
    <header className='banner' style={{ backgroundImage:`url(${baseUrlImages}${movie?.backdrop_path})`, backgroundSize: "cover", backgroundPosition: "center center"}}>
        <div className="banner__contents">
            <h1 className="banner__title">{movie?.name ||movie?.title || movie?.orignial_name || movie?.original_title}</h1>
            <div className="banner__buttons">
                <button className="banner__button">Play</button>
                <button className="banner__button">My List</button>
            </div>
            <h1 className="banner__description">
                {truncate(movie?.overview, 150)}
            </h1>
        </div>
        <div className="banner--fadeBottom"></div>
    </header>
  )
}

export default Banner